import React, { useEffect, useState } from "react";
import user from "../../assets/img/user 1.svg";
import dele from "../../assets/img/slash.svg";
import edit from "../../assets/img/edit-3.svg";
import comm from "../../assets/img/message-circle.svg";
import like from "../../assets/img/heart.svg";
import likered from "../../assets/img/heart-red.svg";
import { formatDistanceToNow,formatDistance  } from 'date-fns';
import profileimg from "../../assets/img/profile/profile-img.svg"

import {
 getAllComments
} from "../../services/apiPosts";


import { API } from "../../services/api";
import { Link } from "react-router-dom";
const ListPost = (props) => {
  const [visibleComments, setVisibleComments] = useState({});
  const[showComment,SetShowComments]=useState([]);
  const post = props.post;
  const userData = props.userData;
  const profile_image_url = user;
  const toggleCommentsVisibility = async (postId) => {
      setVisibleComments((prev) => {
        const newVisibility = !prev[postId]; // Determine new visibility state
        // Call the API only if the new visibility state is true (i.e., comments are opening)
        if (newVisibility) {
          const comntpayload = { postid: postId };
          getAllComments(comntpayload).then(resComments => {
            SetShowComments(resComments.comments || []);
          }).catch(err => {
            console.error("Error fetching comments:", err);
          });
        }
        return {
          ...prev,
          [postId]: newVisibility, // Toggle visibility for the specific post
        };
      });
    };
  
 
  return (
    <div key={props.index} className="profile-section">
      <div className="single posts">
        <div className="user-post">
          <div className="p-img">
            <div className="post-avatr-wrap">
              
                <img src={userData.profileImage?.url ? API.uploadFilePath + userData.profileImage?.url : profileimg} className="avar-post" alt="User Profile" />
              

              {/* Dynamically set user name */}
               <span className="avatarname-post">{userData.firstName}
              </span> 
              {post.usercommunities.length > 0 && post.usercommunities[0].membertype.length > 0 ? (
                <span className="avatarname-wrp">{post.usercommunities[0].membertype[0].memberTypeDisplayName}</span>
              ) : (
                <span className="avatar-role"></span>
              )}
             
              <span className="timing">{formatDistanceToNow(new Date(post.createdAt), { addSuffix: true })}</span>
            </div>
          </div>
        </div>

          <div className="community-itmpost-right">
         <h5 className="comunity-name-post mb-0"></h5>
          {post.postcommunity && post.postcommunity.length > 0 && (
            <span className="user-role-wp">{post.postcommunity.length > 0 ? post.postcommunity[0]?.communityName : ""}</span>
          )}

          {post.topic.length > 0 && (
             <span className="user-role-wp">{post.topic.length > 0 ? post.topic[0].topicTitle : ""}</span>
          )}
             
            <div className="moreoption">

              
                <div class="dropdown">
                  <button className="more" onClick={() => props.setShow(true)}>&#x22EE;</button>
                  <div class="dropdown-content">
                    <a class="button edit" href="#" onClick={(e) => {e.preventDefault();props.handleEdit(post)}}>  <img src={edit} className="edit-img" alt="Comments" /> Edit</a>

                    <a class="button delet" onClick={(e) => {e.preventDefault();props.DeletPost(post._id)}} href="#">
                      <img src={dele} className="edit-img" alt="Comments" /> Delete</a>
                  </div>

                </div>

            </div>
          </div>
        </div>
     

      
        <p className="post-tittle"><strong>{post.postTitle}</strong></p>
        <div className="post-content" dangerouslySetInnerHTML={{ __html: post.postDescription }} />

     {
      post.topicId &&(

         <div className="user-like_coment-share">
        <div className="like_comment">
          <div className="l-Cwrapper">
              <img src={comm} className="comment-icon" alt="Comments" /> <span>{post.comments.length > 0 ? post.comments[0].totalcomments : ""}</span> 
              <Link onClick={(e) => { e.preventDefault(); toggleCommentsVisibility(post._id) }}>Comments</Link>
              </div>
              <div className="l-Cwrapper ">
                <img
                  src={post.likes.length > 0  ? likered : like}
                  className="comment-icon"
                  alt="Likes"
                /><span>{post.likes.length > 0 ? post.likes[0].totallikes : ""}</span>
          Likes
              </div>

           
          
        </div>

        
      </div>

      )
     }

     
     
<div className="text-space comment-box-post">
        
        {/* List Comments Section */}
        {visibleComments[post._id] && showComment.length > 0 && (
          <div>{/* Wrap the elements in a parent div */}
            <h6>Comments</h6>
            <div className="comments-wrapper">
              {showComment.map((comment, index) => (

                <div key={index} className="comment-itm d-flex">
                  {comment.userId.profileImage ? (
                    <img src={process.env.REACT_APP_IMAGE_URL + comment.userId.profileImage.url} className="avar-logo people-user comment" alt="User" />
                  ) : (<img src={user} className="avar-logo people-user comment" alt="User" />)}

                  <div className="coment-box d-flex flex-column">
                    <div className="text-comment d-flex justify-content-between">
                      <div className="avatar_name">{comment.userId.firstName} {comment.userId.lastName}</div>
                      <span className="date-sec"> {formatDistanceToNow(new Date(comment.createdAt), { addSuffix: true })}</span>
                    </div>
                    <p>{comment.comment}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
      
    </div>
  )


};
export default ListPost;